import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Pagination from "@mui/material/Pagination";
import Button from "@mui/material/Button";
import AgentEditModal from "./AgentEditModal/AgentEditModal";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgba(243, 244, 251, 1)",
    color: "rgba(86, 99, 202, 1)",
    fontSize: "16px",
    fontWeight: "600",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "rgba(19, 19, 19, 1)",
    border: 0,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "rgba(220, 222, 243, 0.1)",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "rgba(220, 222, 243, 0.35)",
  },
}));

export default function TableAgents({ agents = [] }) {
  const [page, setPage] = React.useState(1);
  const [openModal, setOpenModal] = React.useState(false);
  const [selectedAgentId, setSelectedAgentId] = React.useState(null);

  const rowsPerPage = 10;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleOpenEditModal = (id) => {
    setSelectedAgentId(id);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedAgentId(null);
  };

  const reversedAgents = agents
  const paginatedAgents = reversedAgents.slice(
      (page - 1) * rowsPerPage,
      page * rowsPerPage
  );

  return (
      <Paper sx={{ boxShadow: "none" }}>
        <TableContainer>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Имя</StyledTableCell>
                <StyledTableCell>Фамилия</StyledTableCell>
                <StyledTableCell>Телефон</StyledTableCell>
                <StyledTableCell align="right">Фото</StyledTableCell>
                <StyledTableCell align="right">Действия</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedAgents.length > 0 ? (
                  paginatedAgents.map((agent) => (
                      <StyledTableRow key={agent.id}>
                        <StyledTableCell>{agent.name}</StyledTableCell>
                        <StyledTableCell>{agent.surname}</StyledTableCell>
                        <StyledTableCell>{agent.phone_number}</StyledTableCell>
                        <StyledTableCell align="right">
                          {agent.image_path ? (
                              <img
                                  src={`${process.env.REACT_APP_API_URL}/api/v1/property/${agent.image_path}?t=${Date.now()}`}
                                  alt={agent.name}
                                  width={50}
                                  height={50}
                                  style={{borderRadius: "50%", objectFit: "cover"}}
                              />

                          ) : (
                              "Нет фото"
                          )}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          <Button
                              size="small"
                              onClick={() => handleOpenEditModal(agent.id)}
                              style={{
                                backgroundColor: "#D1EFCE",
                              }}
                          >
                            Детальнее
                          </Button>
                        </StyledTableCell>
                      </StyledTableRow>
                  ))
              ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={6} align="center">
                      Нет данных
                    </StyledTableCell>
                  </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {agents.length > rowsPerPage && (
            <Pagination
                color="primary"
                page={page}
                count={Math.ceil(agents.length / rowsPerPage)}
                onChange={handleChangePage}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                }}
            />
        )}

        <AgentEditModal
            open={openModal}
            onClose={handleCloseModal}
            agentId={selectedAgentId}
        />
      </Paper>
  );
}
